/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface DailyProgressDto
 */
export interface DailyProgressDto {

    /**
     * Member-local day the progress refers to (YYYY-MM-DD).
     *
     * @type {string}
     * @memberof DailyProgressDto
     * @example 2026-07-07
     */
    date: string;

    /**
     * Total sets planned across every program-session scheduled for today (goal denominator).
     *
     * @type {number}
     * @memberof DailyProgressDto
     * @example 24
     */
    goal: number;

    /**
     * Sets actually executed today (set-level metric documents recorded in Elastic).
     *
     * @type {number}
     * @memberof DailyProgressDto
     * @example 16
     */
    completed: number;

    /**
     * Completion percentage 0–100 (completed / goal, rounded, capped at 100).
     *
     * @type {number}
     * @memberof DailyProgressDto
     * @example 67
     */
    progress: number;
}
